import {Http, http} from "../http";
import {Company} from "../company";
import moment from "moment/moment";

interface AdditionCards{
    MainStatus : string;
    Name : string;
    PaymentSys : string;
    EncryptedPan : string;
    Pan : string;
    CardHolder: string;
    CardStat : string;
    ExpDate : string;
    Currency : string;
}

interface MainCards{
    MainStatus : string;
    AdditionNumb : number;
    BlockedBy : string;
    Name : string;
    Iban : string;
    IBANStat : string;
    OpenDate : string;
    Currency : string;
    AdditionCards : AdditionCards[];
    Pan: string;
}

export interface NewCards{
    newBusinessCards : {
        MsgStatus : string;
        MainCards : MainCards[]
    }
}

export interface NewCardBalanceRequest{
    encryptedPanList : any []
}

export interface NewCardBalanceResponse{
    businessCardsBalance : {
        MsgStatus : string;
        CardInfoResponses : {
            Pan : string;
            Balance? : number;
            BlockedBy : string;
        }[]
    }
}

export interface NewCardLimitResponse{
    businessCardsLimit : {
        MsgStatus : string;
        CardInfoResponses : {
            Pan : string;
            ResidualAmount? : number
        }[]
    }
}

export const getNewCards = async (customerNo: Company): Promise<NewCards> => {
    // 1001301
    const { data } = await http.get<NewCards>(`brcards/get-new-business-cards-by-cif/${customerNo.customerNo}`);
    return data;
};


export const getNewCardBalance = async (customerNo: Company, post_data : NewCardBalanceRequest): Promise<NewCardBalanceResponse> => {
    //${customerNo.customerNo}
    const { data } = await http.post<NewCardBalanceResponse>(`brcards/get-new-business-cards-balance-by-pan/${customerNo.customerNo}`, post_data);
    return data;
}

export const getNewCardLimit = async (customerNo: Company, post_data : NewCardBalanceRequest): Promise<NewCardLimitResponse> => {
    //${customerNo.customerNo}
    const { data } = await http.post<NewCardLimitResponse>(`brcards/get-new-business-cards-limit-by-pan/${customerNo.customerNo}`, post_data);
    return data;
}

export const getCardExtreExcelByIban = async (formData:any,lang:any,otp?:any) : Promise<MainCards> =>{
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)

    const {data} = await httpNew.post<any>(`file/get-card-extre-excel-by-iban/${formData.customerNo}`, { cardtype: formData.cardType, iban: formData.iban, startDate, endDate })
    return data;
}
export const getCardExtrePdfByIban = async (formData:any,lang:any,otp?:any) : Promise<MainCards> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)

    const {data} = await httpNew.post<any>(`file/get-card-extre-pdf-by-iban/${formData.customerNo}`, { cardtype: formData.cardType, iban: formData.iban, startDate, endDate })
    return data;
}


export const getCardExtreExcelByPan = async (formData:any,lang:any) : Promise<any> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)

    const body: any = { cardtype: formData.cardType, pan: formData.pan, startDate, endDate }
    if (formData.otp) body.otp = formData.otp
    const {data} = await httpNew.post<any>(`file/get-card-extre-excel-by-pan/${formData.customerNo}`, body)
    return data;
}

export const getCardExtrePdfByPan = async (formData:any,lang:any) : Promise<any> => {
    let startDate = moment(formData.startDate).format("DD.MM.YYYY");
    let endDate = moment(formData.endDate).format("DD.MM.YYYY");
    const httpNew = new Http(lang)

    const body: any = { cardtype: formData.cardType, pan: formData.pan, startDate, endDate }
    if (formData.otp) body.otp = formData.otp
    const {data} = await httpNew.post<any>(`file/get-card-extre-pdf-by-pan/${formData.customerNo}`, body)
    return data;
}